import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, Form, submit } from 'redux-form/immutable';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FileUpload from 'material-ui/svg-icons/file/file-upload';
import ActionPrint from 'material-ui/svg-icons/action/print';
import { Tabs, Tab } from 'material-ui/Tabs';
import Chip from 'material-ui/Chip';
import _ from 'lodash';
import { fromJS } from 'immutable';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Badge from 'material-ui/Badge';
import {
  TextField,
  DatePicker,
  SelectField,
} from 'redux-form-material-ui';

import TasksTable from '../TasksTable';
import { showDialog, hideDialog, isDialogOpen, showError } from '../../actions/dialogs';
import { fetchEmployees } from '../../actions/employees';
import TaskDialog from '../TaskDialog';
import { saveJobFormHandler, fetchTasksRoutine, removeTasksRoutine } from '../../routines';
import GenerateLabelsDialog from '../GenerateLabelsDialog';
import TaskPhotosDialog from '../TaskPhotosDialog';
import { toArray, toJSSafe, sortStrings, id } from '../../utils/helper';
import { hasPermission } from '../../utils/authenticated';
import ReduxDialog from '../Common/ReduxDialog';
import Loading from '../Common/Loading';

import commonStyles from '../styles';
import styles from './styles';

import {
  fetchJob,
  addTag,
  removeTag,
  addTask,
} from '../../actions/jobs';
import StagesTable from '../StagesTable/index';
import { renderResources } from '../../utils/reduxforms';

class JobDialog extends Component {
  static propTypes = {
    // fetchJob: PropTypes.func.isRequired,
    fetchTasks: PropTypes.func.isRequired,
    fetchEmployees: PropTypes.func.isRequired,
    employees: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,

    dialogs: PropTypes.object.isRequired,
    showDialog: PropTypes.func,
    hideDialog: PropTypes.func,
    showError: PropTypes.func,

    job: PropTypes.object.isRequired,
    tasks: PropTypes.object.isRequired,

    addTag: PropTypes.func.isRequired,
    removeTag: PropTypes.func.isRequired,
    addTask: PropTypes.func.isRequired,
    removeTask: PropTypes.func.isRequired,

    onDiscard: PropTypes.func,
    onSave: PropTypes.func,

    handleSubmit: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  state = {
    selectedTasks: [],
  };

  componentWillMount() {
    this.props.fetchTasks(this.props.job.id, { limit: 10 });
    this.props.fetchEmployees();

    this.setState({
      editable: hasPermission(['Administrator', 'JobCreator']),
    });
  }

  handleOriginChange = (a, b, c) => {
    console.log('handleOriginChange', a, b, c);
  };

  handleRequestCloseTag = (tag) => {
    this.props.hideDialog('tag');
    if (tag) {
      this.props.addTag(this.props.job, tag);
    }
  };

  handleUpload = () => {
    console.log('handleUpload');
    this.props.showDialog('taskUpload', { job: this.props.job });
  };

  handleAddResources = (spec) => {
    console.log('handleAddResource', spec);
    const resources = _.range(spec.quantity).map(() => _.assign(_.omit(spec, ['quantity']), { id: id() }));
    this.props.addResources(this.props.job, resources);
    this.setState({
      resource: 'added',
    });
  };

  handleResetResources = (state) => {
    console.log('state', state);
    return state;
  };

  handleGenerateLabels = () => {
    if (this.props.job.tasks && this.props.job.tasks.count > 0) {
      this.props.showDialog('generateLabels', { tasks: this.state.selectedTasks.length > 0 ? this.state.selectedTasks : toArray(this.props.tasks) });
    } else {
      this.props.showError('Error', 'This job does not currently have any tasks');
    }
  };

  handleTaskProfilesChanged = (taskProfiles) => {
    console.log('handleTaskProfilesChanged', taskProfiles);
  };

  handleEditResource = (resource) => {
    console.log('handleEditResource', resource);
    this.props.setResourceEmployee(this.props.job, resource, resource.employee);
  };

  handleRemoveResource = (resource) => {
    console.log('handleRemoveResource', resource);
    this.props.removeResource(this.props.job, resource);
  };

  handleEditTask = (task) => {
    console.log('handleEditTask', task);
    this.props.showDialog('task', { task });
  };

  handleRemoveTask = (task) => {
    const context = {
      type: 'warning',
      title: 'Remove Task?',
      message: 'Are you sure you wish to remove this task?',
      buttons: [
        <FlatButton
          label="Cancel"
          onClick={() => this.props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Remove"
          onClick={() => {
            this.props.hideDialog('confirm');
            this.props.removeTask(task);
          }}
        />,
      ],
    };

    this.props.showDialog('confirm', context);
  };

  handleDiscard = () => {
    this.props.hideDialog('job');
  };

  // TODO dup above
  handleRequestClose = () => {
    this.props.hideDialog('job');
  };

  handleTaskSelection = (selectedIdxs, selectedTasks) => {
    console.log('selectedIdxs', selectedIdxs);
    console.log('selectedTasks', selectedTasks);

    this.setState({
      selectedTasks,
    });
  }

  renderTags(tags = []) {
    return (<div style={commonStyles.row}>
      { tags.map(this.renderTag) }
    </div>);
  }

  renderTag = (tag) => (<Chip
    key={tag}
    onRequestDelete={() => this.props.removeTag(this.props.job, tag)}
    style={styles.chip}
  >{tag}</Chip>);

  renderOverview(job, editable) {
    return (<div style={styles.tabPage}>
      <div style={commonStyles.row}>
        <Field
          name="reference"
          style={commonStyles.input}
          component={TextField}
          floatingLabelText="Reference"
          floatingLabelFixed
          fullWidth
          readOnly={!editable}
        />
        <Field
          name="customer.name"
          style={commonStyles.input}
          component={TextField}
          floatingLabelText="Customer"
          floatingLabelFixed
          fullWidth
          readOnly={true}
        />
      </div>
      <div style={commonStyles.row}>
        <Field
          name="originId"
          component={SelectField}
          style={commonStyles.input}
          floatingLabelText="Origin"
          floatingLabelFixed
          fullWidth
          readOnly={!editable}
        >
          { toArray(job.customer.addresses).map((address) => {
            return (<MenuItem key={address.id} value={address.id} primaryText={address.line1}/>);
          })}
        </Field>
        <Field
          name="destinationId"
          component={SelectField}
          style={commonStyles.input}
          floatingLabelText="Destination"
          floatingLabelFixed
          fullWidth
          readOnly={!editable}
        >
          { toArray(job.customer.addresses).map((address) => {
            return (<MenuItem key={address.id} value={address.id} primaryText={address.line1}/>);
          })}
        </Field>
      </div>
      <div style={commonStyles.row}>
        <Field
          name="start"
          style={commonStyles.input}
          component={DatePicker}
          floatingLabelText="Start"
          floatingLabelFixed
          fullWidth
          autoOk
          disabled={!editable}
        />
        <Field
          name="end"
          style={commonStyles.input}
          component={DatePicker}
          floatingLabelText="End"
          floatingLabelFixed
          fullWidth
          autoOk
          disabled={!editable}
        />
      </div>
      <div style={commonStyles.row}>
        <Field
          name="description"
          style={commonStyles.input}
          component={TextField}
          floatingLabelText="Description"
          floatingLabelFixed
          fullWidth
          multiLine
          rows={3}
          readOnly={!editable}
        />
      </div>

      <div style={styles.tagsHeader}>
        <label style={styles.tagsLabel}>Tags</label>
        { editable ? <FloatingActionButton
          style={styles.addTag}
          onClick={() => this.props.showDialog('tag', { onRequestClose: this.handleRequestCloseTag })}
          mini
          secondary
        >
          <ContentAdd />
        </FloatingActionButton> : null }
      </div>
      { this.renderTags(job.tags, editable) }

      <div style={commonStyles.row}>
        <Field
          name="notes"
          style={commonStyles.input}
          component={TextField}
          floatingLabelText="Notes"
          floatingLabelFixed
          fullWidth
          multiLine
          rows={3}
          readOnly={!editable}
        />
      </div>

    </div>);
  }

  render() {
    const { handleSubmit, job, tasks, tasksLoading } = this.props;
    const { editable } = this.state;

    const buttons = [
      <FlatButton
        key="cancel"
        label={editable ? 'Cancel' : 'Close'}
        onClick={this.handleDiscard}
      />,
    ];

    if (editable) {
      buttons.push(<FlatButton
        key="save"
        label="Save"
        primary
        type="submit"
        onClick={() => this.props.dispatch(submit('job'))}
      />);
    }

    return (
      <ReduxDialog
        name="job"
        title={job.customer.name}
        subTitle={job.description || ''}
        rightToolbar={<div>
          <IconButton tooltip="Upload" onClick={this.handleUpload}><FileUpload color="white"/></IconButton>
          <Badge
            badgeContent={this.state.selectedTasks.length || _.keys(this.props.tasks).length}
            secondary
            badgeStyle={{ top: 12, right: 12 }}
          >
            <IconButton tooltip="Generate Labels" onClick={this.handleGenerateLabels}><ActionPrint color="white"/></IconButton>
          </Badge>
        </div>}
        actions={buttons}
        onRequestClose={() => this.handleRequestClose()}
        titleStyle={{
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
        bodyStyle={styles.body}
        contentStyle={{
          maxWidth: null,
          width: '80%',
        }}
      >
        <Form name="Job" onSubmit={handleSubmit(saveJobFormHandler)} style={styles.form}>
          <Tabs>
            <Tab label="Overview">
              { this.renderOverview(job, editable) }
            </Tab>
            <Tab label="Resources">
              <div style={styles.tabPage}>
                <Field
                  name="resources"
                  component={renderResources}
                  employees={this.props.employees}
                  editable={editable}
                />
              </div>
            </Tab>
            <Tab label="Stages">
              <div style={styles.tabPage}>
                <StagesTable stages={job.profile ? this.props.job.profile.stages || [] : []}/>
              </div>
            </Tab>
            {/*<Tab label="Task Profiles">*/}
            {/*<div style={styles.tabPage}>*/}
            {/*<TaskProfileDrilldown*/}
            {/*taskProfiles={job.taskProfiles || []}*/}
            {/*onChange={this.handleTaskProfilesChanged}*/}
            {/*selectable*/}
            {/*/>*/}
            {/*</div>*/}
            {/*</Tab>*/}
            <Tab label={`Tasks (${job.tasks && job.tasks.count ? job.tasks.count : 0})`}>
              <div style={styles.tabPage}>
                { !tasksLoading ? <TasksTable
                  job={job}
                  tasks={tasks}
                  selectable
                  multiSelectable
                  onEdit={editable ? this.handleEditTask : null}
                  onRemove={editable ? this.handleRemoveTask : null}
                  onViewImages={(task) => this.props.showDialog('taskPhotos', { task })}
                  onRowSelection={this.handleTaskSelection}
                /> : <Loading/> }
              </div>
            </Tab>
          </Tabs>
        </Form>

        { isDialogOpen(this.props.dialogs, 'task') ?
          <TaskDialog onRequestClose={() => this.props.hideDialog('task')} /> : null }

        { isDialogOpen(this.props.dialogs, 'generateLabels') ? <GenerateLabelsDialog /> : null }
        { isDialogOpen(this.props.dialogs, 'taskPhotos') ? <TaskPhotosDialog /> : null }
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'job',  // a unique identifier for this form
  // onSubmit: (values, dispatch, props) => {
  //   const job = values
  //     // .set('profile', fromJS(props.job.profile || {}))
  //     // .set('taskProfiles', fromJS(props.job.taskProfiles || []))
  //     // .set('resources', fromJS(props.job.resources || {}))
  //     // .set('preferredItems', fromJS(props.job.preferredItems || {}))
  //     // .set('tasks', fromJS(props.job.tasks || { count: 0 }));
  //   return dispatch(saveJobRoutine.trigger({ values: job }));
  // },
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog('job');
  },
})(JobDialog);

function mapStateToProps(state) {
  const dialogs = state.get('dialogs').get('dialogs').toJS();
  const employees = state.get('employees').get('employees').toJS().sort((a, b) => sortStrings(a.name, b.name));

  const res = {
    job: state.get('jobs').get('job').toJS(),
    loading: state.get('jobs').get('loading'),

    tasks: toJSSafe(state.get('tasks').get('tasks')),
    tasksLoading: state.get('tasks').get('loading'),

    employees,

    initialValues: state.get('jobs').get('job').toJS(),
    dialogs,
  };
  return res;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchJob,
    fetchTasks: (jobId, query) => fetchTasksRoutine.trigger({ jobId, query }),
    fetchEmployees,

    addTag,
    removeTag,
    // addResources,
    // removeResource,
    // setResourceEmployee,

    addTask,
    removeTask: (task) => removeTasksRoutine.trigger({ tasks: [task] }),

    showDialog,
    hideDialog,
    showError,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/JobDialog/index.js